import config from '@/config/index.js'
import blockchain from '@/config/blockchain.js'

const state = () => ({
	// 自适应屏幕: pc/mobile
	responsive: null,
    // 当前用户所有的套装
    sets: [],
    // 当前用户所有的收藏夹
    collections: [],
    // 执照集合
    licenses: [
        { id: 0, name: 'CBE-CC0', description: 'CC0 1.0 Universal' },
        { id: 1, name: 'CBE-ECR', description: 'Exclusive Commercial Rights (No Creator Retention of Exploitation Rights)' },
        { id: 2, name: 'CBE-NECR', description: 'Non-Exclusive Commercial Rights (Creator Retains Exploitation Rights)' },
        { id: 3, name: 'CBE-NECR-HS', description: 'Non-Exclusive Commercial Rights (Creator Retains Exploitation Rights) & Termination for Hate Speech' },
        { id: 4, name: 'CBE-PR', description: 'Personal Use License' },
        { id: 5, name: 'CBE-PR-HS', description: 'Personal Use License with Termination for Hate Speech' },
    ],
    // 支付代币价格
    paymentTokenPrice: {
        ETH: 0,
        MATIC: 0
    },
    // 货币价格集合
    prices: [
        { currency: 'UN', price: 0 },
        { currency: 'BTC', price: 0 },
        { currency: 'ETH', price: 0 },
        { currency: 'MATIC', price: 0 },
        { currency: 'BNB', price: 0 },
        { currency: 'OKB', price: 0 },
        { currency: 'SHIB', price: 0 },
        { currency: 'SOL', price: 0 },
        { currency: 'LINK', price: 0 },
        { currency: 'UNI', price: 0 },
        { currency: 'USDC.e', price: 0 },
        { currency: 'USDC', price: 0 },
        { currency: 'USDT', price: 0 },
        { currency: 'DAI', price: 0 },
        { currency: 'LTC', price: 0 },
        { currency: 'DOT', price: 0 },
        { currency: 'BCH', price: 0 },
        { currency: 'XRP', price: 0 },
        { currency: 'EOS', price: 0 },
        { currency: 'ADA', price: 0 },
        { currency: 'XMR', price: 0 },
        { currency: 'POL', price: 0 },
        { currency: 'WBTC', price: 0 }
    ],
    // 全局切换区块链网络
    blockchain: null,
	// 区块链集合
	blockchains: [],
    // 提示信息
    snackbarMessage: null,
    // 搜索
    search: {
        blockchain: null,
        wrappedCurrency: null,
        quoteCurrency: null,
        totalRewardRatios: [10,40],
        futureRewardRatios: [90,95],
        numberOfGenerations: [10,30]
    },
    // 加密货币封装权限
    cryptoWrapPermission: true,
    // 加密货币产品
    cryptoProducts: [],
    // 加密货币盈利预期
    cryptoProfitExpectancies: [],
    // 交易经验
    tradingExperience: null,
    // 鼓舞人心的人或事物，交易灵感
    inspiration: null,
    // 持续财富答案
    lastingWealthAnswer: null,
    // 交易类型答案集合下标
    tradingTypeAnswerArrayIndex: null,
    // 交易类型答案
    tradingTypeAnswer: null
})

const getters = {
	responsive: state => state.responsive,
	sets: state => state.sets,
	collections: state => state.collections,
	licenses: state => state.licenses,
	paymentTokenPrice: state => state.paymentTokenPrice,
	prices: state => state.prices,
	blockchain: state => {
        if (state.blockchain) {
            return state.blockchain;
        }
        state.blockchain = localStorage.getItem('untrading-blockchain');
        return state.blockchain;
    },
	blockchains: state => {
		if(config.env == 'prod') {
			return blockchain.mainnet;
		} else {
			return blockchain.testnet;
		}
	},
    snackbarMessage: state => state.snackbarMessage,
    search: state => {
        let search = JSON.parse(localStorage.getItem('untrading-search'));
        if (search) {
            state.search = search;
        }
        // if (state.search) {
        //     return state.search;
        // }
        // state.search = (state.search != null) ? state.search : {};
		return state.search;
    },
    cryptoWrapPermission: state => state.cryptoWrapPermission,
    cryptoProducts: state => state.cryptoProducts,
    cryptoProfitExpectancies: state => state.cryptoProfitExpectancies,
    tradingExperience: state => {
        if (state.tradingExperience) {
            return state.tradingExperience;
        }
        state.tradingExperience = localStorage.getItem('untrading-tradingExperience');
        return state.tradingExperience;
    },
    inspiration: state => {
        if (state.inspiration) {
            return state.inspiration;
        }
        state.inspiration = localStorage.getItem('untrading-inspiration');
        return state.inspiration;
    },
    lastingWealthAnswer: state => {
        if (state.lastingWealthAnswer) {
            return state.lastingWealthAnswer;
        }
        state.lastingWealthAnswer = localStorage.getItem('untrading-lastingWealthAnswer');
        return state.lastingWealthAnswer;
    },
    tradingTypeAnswerArrayIndex: state => {
        if (state.tradingTypeAnswerArrayIndex) {
            return state.tradingTypeAnswerArrayIndex;
        }
        state.tradingTypeAnswerArrayIndex = localStorage.getItem('untrading-tradingTypeAnswerArrayIndex');
        return state.tradingTypeAnswerArrayIndex;
    },
    tradingTypeAnswer: state => {
        if (state.tradingTypeAnswer) {
            return state.tradingTypeAnswer;
        }
        state.tradingTypeAnswer = localStorage.getItem('untrading-tradingTypeAnswer');
        return state.tradingTypeAnswer;
    },
}

const actions = {
	responsiveHandler(context, payload){
		context.commit('responsiveHandler', payload);
	},
    setsHandler(context, payload){
		context.commit('setsHandler', payload);
	},
    collectionsHandler(context, payload){
		context.commit('collectionsHandler', payload);
	},
    licensesHandler(context, payload){
		context.commit('licensesHandler', payload);
	},
    paymentTokenPriceHandler(context, payload){
		context.commit('paymentTokenPriceHandler', payload);
	},
    pricesHandler(context, payload){
		context.commit('pricesHandler', payload);
	},
    blockchainHandler(context, payload){
		context.commit('blockchainHandler', payload);
	},
    snackbarMessageHandler(context, payload){
		context.commit('snackbarMessageHandler', payload);
	},
    searchHandler(context, payload){
		context.commit('searchHandler', payload);
	},
    cryptoWrapPermissionHandler(context, payload){
		context.commit('cryptoWrapPermissionHandler', payload);
	},
    cryptoProductsHandler(context, payload){
		context.commit('cryptoProductsHandler', payload);
	},
    cryptoProfitExpectanciesHandler(context, payload){
		context.commit('cryptoProfitExpectanciesHandler', payload);
	},
    tradingExperienceHandler(context, payload){
		context.commit('tradingExperienceHandler', payload);
	},
    inspirationHandler(context, payload){
		context.commit('inspirationHandler', payload);
	},
    lastingWealthAnswerHandler(context, payload){
		context.commit('lastingWealthAnswerHandler', payload);
	},
    tradingTypeAnswerArrayIndexHandler(context, payload){
		context.commit('tradingTypeAnswerArrayIndexHandler', payload);
	},
    tradingTypeAnswerHandler(context, payload){
		context.commit('tradingTypeAnswerHandler', payload);
	},
}

const mutations = {
	responsiveHandler(state, responsive){
		state.responsive = responsive;
	},
    setsHandler(state, sets){
		state.sets = sets;
	},
    collectionsHandler(state, collections){
		state.collections = collections;
	},
    licensesHandler(state, licenses){
		state.licenses = licenses;
	},
    paymentTokenPriceHandler(state, paymentTokenPrice){
		state.paymentTokenPrice = paymentTokenPrice;
	},
    pricesHandler(state, prices){
		state.prices = prices;
	},
    blockchainHandler(state, blockchain){
        if(blockchain == null){
			localStorage.removeItem('untrading-blockchain');
		} else {
			localStorage.setItem('untrading-blockchain', blockchain);
		}
		state.blockchain = blockchain;
	},
    snackbarMessageHandler(state, snackbarMessage){
        console.log(snackbarMessage);
		state.snackbarMessage = snackbarMessage;
        // 延时清空文本
        setTimeout(() => {
            state.snackbarMessage = null;
        }, 5001);
	},
    searchHandler(state, search){
		localStorage.setItem('untrading-search', JSON.stringify(search));
		state.search = search;
	},
    cryptoWrapPermissionHandler(state, cryptoWrapPermission){
		state.cryptoWrapPermission = cryptoWrapPermission;
	},
    cryptoProductsHandler(state, cryptoProducts){
		state.cryptoProducts = cryptoProducts;
	},
    cryptoProfitExpectanciesHandler(state, cryptoProfitExpectancies){
		state.cryptoProfitExpectancies = cryptoProfitExpectancies;
	},
    tradingExperienceHandler(state, tradingExperience){
        if (tradingExperience) {
            localStorage.setItem("untrading-tradingExperience", tradingExperience);
        } else {
            localStorage.removeItem("untrading-tradingExperience");
        }
		state.tradingExperience = tradingExperience;
	},
    inspirationHandler(state, inspiration){
        if (inspiration) {
            localStorage.setItem("untrading-inspiration", inspiration);
        } else {
            localStorage.removeItem("untrading-inspiration");
        }
		state.inspiration = inspiration;
	},
    lastingWealthAnswerHandler(state, lastingWealthAnswer){
        if (lastingWealthAnswer) {
            localStorage.setItem("untrading-lastingWealthAnswer", lastingWealthAnswer);
        } else {
            localStorage.removeItem("untrading-lastingWealthAnswer");
        }
		state.lastingWealthAnswer = lastingWealthAnswer;
	},
    tradingTypeAnswerArrayIndexHandler(state, tradingTypeAnswerArrayIndex){
        if (tradingTypeAnswerArrayIndex) {
            localStorage.setItem("untrading-tradingTypeAnswerArrayIndex", tradingTypeAnswerArrayIndex);
        } else {
            localStorage.removeItem("untrading-tradingTypeAnswerArrayIndex");
        }
		state.tradingTypeAnswerArrayIndex = tradingTypeAnswerArrayIndex;
	},
    tradingTypeAnswerHandler(state, tradingTypeAnswer){
        if (tradingTypeAnswer) {
            localStorage.setItem("untrading-tradingTypeAnswer", tradingTypeAnswer);
        } else {
            localStorage.removeItem("untrading-tradingTypeAnswer");
        }
		state.tradingTypeAnswer = tradingTypeAnswer;
	},
}

export default {
	state,
	getters,
	actions,
	mutations
}